module.exports = __webpack_public_path__ + "media/flags/th-81f11216.svg";